var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8600_15100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.473 27.832H158.457M124.316 50.0977H158.457M147.324 83.4961H154.746M117.637 83.4961H125.059M87.9492 83.4961H95.3711M58.2617 83.4961H65.6836M27.832 27.832H61.2305V53.8086H27.832V27.832Z",
    stroke: "#D1D1D1",
    strokeWidth: 11.1328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3867 184.434C68.9312 184.434 87.207 166.158 87.207 143.613C87.207 121.069 68.9312 102.793 46.3867 102.793C23.8423 102.793 5.56641 121.069 5.56641 143.613C5.56641 166.158 23.8423 184.434 46.3867 184.434Z",
    stroke: "#D1D1D1",
    strokeWidth: 11.1328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2305 128.77L31.543 158.457M31.543 128.77L61.2305 158.457M77.2487 116.895H169.59C177.788 116.895 184.434 110.249 184.434 102.051V20.4102C184.434 12.2123 177.788 5.56641 169.59 5.56641H20.4102C12.2123 5.56641 5.56641 12.2123 5.56641 20.4102V102.051C5.56641 108.747 10.001 114.405 16.0925 116.255",
    stroke: "#D1D1D1",
    strokeWidth: 11.1328,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8600_15100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 190,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentEmpty);
export default __webpack_public_path__ + "static/media/payment-empty.b33f30630e3181c695c4881546d12749.svg";
export { ForwardRef as ReactComponent };